import { idPropType } from "constants/app";
import { arrayOf, bool, number, shape, string } from "prop-types";

export const SECTIONS_TAB = "sections";
export const COVERAGE_TAB = "coverage";
export const CHECKBOX_COLUMN_WIDTH = 75;

export const COVERAGE_PANE_NARROW_WIDTH = "132px";

export const COVERAGE_SECTIONS_WIDTH = "300px";
export const COVERAGE_SECTIONS_MIN_WIDTH = "200px";
export const COVERAGE_SECTIONS_MAX_WIDTH = "40%";

export const COVERAGE_DOCUMENT_WIDTH = "32%";
export const COVERAGE_DOCUMENT_MIN_WIDTH = "240px";
export const COVERAGE_DOCUMENT_MAX_WIDTH = "66%";

export const COVERAGE_TABLE_MIN_WIDTH = "320px";

export const DRAWER_DOCUMENT_WIDTH = "66%";
export const DRAWER_REQUIREMENTS_MIN_WIDTH = "320px";

export const paragraphRowPropTypes = shape({
  addressedIn: arrayOf(string),
  categories: arrayOf(string),
  id: idPropType,
  isGap: bool,
  isHeading: bool,
  page: number,
  paragraphIndex: number,
  pointIds: arrayOf(string),
  refs: arrayOf(string),
  text: string,
});
